export enum DeadlineNameEnum {
  ClassRegistration = 'class_registration',
  CulminationEvent = 'culmination_event',
  FamilyPresentation = 'family_presentation',
  ProjectApplication = 'project_application',
  PlatformFeeding = 'platform_feeding',
  StudentBio = 'student_bio',
  TeacherBio = 'teacher_bio',
  SalesStart = 'sales_start',
  SalesEnd = 'sales_end',
  AutographInvite = 'autograph_invite',
  AutographDay = 'autograph_day'
}
